export default (function (token, service, r, a, restriction) {
    var resources = getArray(r);
    var actions = getArray(a);
    var permissions = {};
    resources.forEach(function (resource) {
        actions.forEach(function (action) {
            var allow = token.isAllowed({ service: service, resource: resource, action: action, restriction: restriction });
            if (allow) {
                permissions["" + resource + action] = allow;
            }
        });
    });
    var total = (actions.length * resources.length);
    if (Object.keys(permissions).length !== total) {
        return false;
    }
    return true;
});
function getArray(arr) {
    if (!Array.isArray(arr)) {
        return [arr];
    }
    return arr;
}
